import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Text } from '_/components';
import themes from '_/constants/themes';
import { fontFamily } from '_/config/theme';
import { useTranslation } from 'react-i18next';

type Props = {
  isToday?: boolean;
};

export function EmptyDeliveries({ isToday = true }: Props) {
  const { t: translate } = useTranslation();

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Feather name="package" size={58} color={themes.colors.graySecondary} />
      </View>

      <Text style={styles.title}>
        {isToday ? translate('deliveries.emptyTitle') : translate('deliveries.empty.notFoundTitle')}
      </Text>

      <Text style={styles.subtitle}>
        {isToday
          ? translate('deliveries.emptyDesc')
          : translate('deliveries.empty.tryAgainFilters')}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    paddingBottom: 60,
  },
  iconContainer: {
    height: 80,
    width: 80,
    borderRadius: 40,
    backgroundColor: themes.colors.lightPrimary,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 16.5,
    fontFamily: fontFamily.semibold,
    color: themes.colors.grayPrimary,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    marginTop: 6,
    color: themes.colors.graySecondary,
    textAlign: 'center',
    lineHeight: 18,
  },
});
